import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBottle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBottle"><Path d="M10 1C9.72386 1 9.5 1.22386 9.5 1.5C9.5 1.77614 9.72386 2 10 2V6.5C10 6.97214 9.77771 7.41672 9.4 7.7L7 9.5C6.37049 9.97214 6 10.7131 6 11.5V20.5C6 21.8807 7.11929 23 8.5 23H15.5C16.8807 23 18 21.8807 18 20.5V11.5C18 10.7131 17.6295 9.97214 17 9.5L14.6 7.7C14.2223 7.41672 14 6.97214 14 6.5V2C14.2761 2 14.5 1.77614 14.5 1.5C14.5 1.22386 14.2761 1 14 1H10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBottle;
